module.exports = __webpack_public_path__ + "static/img/beans-off.ba75bead.png";